(function () {
  'use strict';

  if (window.__wokoraVatPricingV3) return;
  window.__wokoraVatPricingV3 = true;

  var config = window.WOKORA_VAT_CONFIG || {};
  var taxesIncluded = config.taxesIncluded !== false;
  var scheduled = false;

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return '€ ' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function numericRate(value) {
    if (value === '' || value == null) return null;
    var rate = Number(value);
    return Number.isFinite(rate) && rate >= 0 ? rate : null;
  }

  function priceParts(rawCents, rate, included) {
    var raw = Math.max(0, Number(rawCents) || 0);
    if (rate == null) return { known: false, raw: raw, net: raw, gross: raw };
    var divisor = 100 + rate;
    return {
      known: true,
      raw: raw,
      net: included ? Math.round(raw * 100 / divisor) : raw,
      gross: included ? raw : Math.round(raw * divisor / 100)
    };
  }

  function rateLabel(rate) {
    if (rate == null) return '';
    return Number.isInteger(rate) ? String(rate) : String(Math.round(rate * 100) / 100).replace('.', ',');
  }

  function addStyles() {
    if (document.getElementById('wokora-vat-pricing-styles-v3')) return;
    var style = document.createElement('style');
    style.id = 'wokora-vat-pricing-styles-v3';
    style.textContent = [
      '.fn-vat-price{display:inline-flex;flex-direction:column;align-items:flex-end;gap:2px;max-width:100%}',
      '.fn-vat-price__primary-line{display:flex;align-items:baseline;justify-content:flex-end;gap:6px;flex-wrap:wrap}',
      '.fn-vat-price__primary{font:inherit;font-weight:800;color:inherit}',
      '.fn-vat-price__tax-label{font-size:10.5px;font-weight:800;line-height:1.15;color:#607168;white-space:nowrap}',
      '.fn-vat-price__secondary{display:block;font-size:10.5px;font-weight:650;line-height:1.25;color:#718077;text-align:right}',
      '.fn-vat-price--pdp{display:flex;align-items:flex-start;gap:3px}',
      '.fn-vat-price--pdp .fn-vat-price__primary-line{justify-content:flex-start}',
      '.fn-vat-price--pdp .fn-vat-price__primary{font-size:clamp(1.65rem,3vw,2.15rem);line-height:1.05}',
      '.fn-vat-price--pdp .fn-vat-price__tax-label{font-size:12px}',
      '.fn-vat-price--pdp .fn-vat-price__secondary{font-size:12.5px;text-align:left}',
      '.fn-vat-price--default{align-items:flex-start}',
      '.fn-vat-price--default .fn-vat-price__primary-line{justify-content:flex-start}',
      '.fn-vat-price--default .fn-vat-price__secondary{text-align:left}',
      '.b2b-card__price-row .fn-vat-price{margin-left:auto}',
      '.wk-col-v71 .b2b-card__price-row:only-child>.b2b-card__price-label{display:inline!important;visibility:visible!important}',
      '.wk-col-v71 .b2b-card__price-row:only-child>.fn-vat-price{display:inline-flex!important}',
      '.wk-col-v71 .b2b-card__price-row:only-child{justify-content:space-between!important}',
      '.wokora-vat-mini{display:block;margin-top:3px;color:#66776e;font-size:10.5px;font-weight:750;line-height:1.2}',
      '.fn-vat-cart-line-note{display:block;margin-top:2px;color:#6b7b72;font-size:10.5px;font-weight:650;line-height:1.2}',
      '.fn-vat-status{margin:7px 0 0;color:#607168;font-size:11.5px;line-height:1.35}',
      '.w19-drawer-item__prices .fn-vat-price{align-items:flex-end}',
      '.w19-drawer-item__prices .fn-vat-price__primary{font-size:inherit}',
      '.w19-drawer-item__prices .fn-vat-price__secondary{font-size:10px}',
      '@media(max-width:760px){html body.template-collection .product-card__title{display:block!important;min-height:0!important;max-height:none!important;overflow:visible!important;white-space:normal!important;text-overflow:clip!important;-webkit-box-orient:initial!important;-webkit-line-clamp:unset!important;line-clamp:unset!important}.fn-vat-price__tax-label,.fn-vat-price__secondary{font-size:10px}.fn-vat-price--pdp .fn-vat-price__tax-label{font-size:11px}.fn-vat-price--pdp .fn-vat-price__secondary{font-size:11.5px}.fn-vat-price--pdp .fn-vat-price__primary{font-size:1.7rem}}'
    ].join('');
    document.head.appendChild(style);
  }

  function renderVatPrice(el, rawPrice, rawCompare, rate) {
    if (!el) return;
    var included = String(el.dataset.vatTaxesIncluded || taxesIncluded) !== 'false';
    var parts = priceParts(rawPrice, rate, included);
    var compareParts = priceParts(rawCompare, rate, included);
    var primary = el.querySelector('[data-vat-primary]');
    var compare = el.querySelector('[data-vat-compare]');
    var primaryLabel = el.querySelector('[data-vat-primary-label]');
    var secondary = el.querySelector('[data-vat-secondary]');

    el.dataset.vatRaw = String(Number(rawPrice) || 0);
    el.dataset.vatCompareRaw = String(Number(rawCompare) || 0);
    if (primary) primary.textContent = money(parts.known ? parts.net : parts.raw);
    if (primaryLabel) primaryLabel.textContent = parts.known ? 'excl. BTW' : (included ? 'incl. BTW' : 'excl. BTW');
    if (secondary) {
      secondary.textContent = parts.known
        ? money(parts.gross) + ' incl. BTW · BTW ' + rateLabel(rate) + '%'
        : (included ? 'BTW-tarief wordt bij checkout bevestigd' : 'BTW wordt bij checkout berekend');
    }

    var onSale = Number(rawCompare || 0) > Number(rawPrice || 0);
    if (compare) {
      compare.hidden = !onSale;
      compare.textContent = onSale ? money(compareParts.known ? compareParts.net : compareParts.raw) : '';
    }
    if (primary) primary.classList.toggle('price__sale', onSale);
  }

  function selectedVariant(form) {
    if (!form) return null;
    var select = form.querySelector('[data-variant-select],select[name="id"],input[name="id"]');
    var json = form.querySelector('[data-variants-json]');
    if (!select || !json) return null;
    try {
      var variants = JSON.parse(json.textContent || '[]');
      return variants.find(function (variant) { return String(variant.id) === String(select.value); }) || null;
    } catch (error) {
      return null;
    }
  }

  function syncProduct(root) {
    var scope = root || document;
    var updated = false;
    scope.querySelectorAll('[data-product-root]').forEach(function (productRoot) {
      var dynamicPrice = productRoot.querySelector('[data-vat-price][data-vat-dynamic]');
      var form = productRoot.querySelector('[data-product-form]');
      if (!dynamicPrice || !form) return;
      var variant = selectedVariant(form);
      if (!variant) return;
      var rate = numericRate(productRoot.dataset.vatRate || dynamicPrice.dataset.vatRate);
      renderVatPrice(dynamicPrice, variant.price, variant.compare_at_price, rate);
      updated = true;

      var sticky = document.querySelector('[data-sticky-atc]');
      var stickyPrice = sticky && sticky.querySelector('[data-sticky-price]');
      if (stickyPrice) {
        var stickyParts = priceParts(variant.price, rate, taxesIncluded);
        stickyPrice.textContent = money(stickyParts.known ? stickyParts.net : stickyParts.raw);
        var stickyNote = sticky.querySelector('.wokora-vat-mini');
        if (!stickyNote) {
          stickyNote = document.createElement('small');
          stickyNote.className = 'wokora-vat-mini';
          stickyPrice.insertAdjacentElement('afterend', stickyNote);
        }
        stickyNote.textContent = stickyParts.known ? 'excl. BTW' : (taxesIncluded ? 'incl. BTW' : 'BTW bij checkout');
      }
    });
    if (updated) document.dispatchEvent(new CustomEvent('wokora:vat-updated'));
  }

  function addFallbackLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('.b2b-card__prices,.price[data-price]').forEach(function (container) {
      if (container.querySelector('[data-vat-price]') || container.querySelector(':scope > .wokora-vat-mini')) return;
      if (container.closest('[data-product-root]')) return;
      var label = document.createElement('small');
      label.className = 'wokora-vat-mini';
      label.textContent = taxesIncluded ? 'incl. BTW' : 'excl. BTW';
      container.appendChild(label);
    });
  }

  function enhanceMobileVat(root) {
    var scope = root || document;
    scope.querySelectorAll('.wk73-mobile-bar__total').forEach(function (total) {
      if (total.querySelector('.wokora-vat-mini')) return;
      var badge = document.createElement('small');
      badge.className = 'wokora-vat-mini';
      badge.textContent = taxesIncluded ? 'totaal incl. BTW' : 'BTW bij checkout';
      total.appendChild(badge);
    });
  }

  function enhance(root) {
    addStyles();
    addFallbackLabels(root);
    syncProduct(root);
    enhanceMobileVat(root);
  }

  function scheduleEnhance() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      enhance(document);
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.closest('[data-product-form]')) return;
    window.setTimeout(function () { syncProduct(document); }, 0);
  });
  window.addEventListener('foodnet:variant-change', function () {
    window.setTimeout(function () { syncProduct(document); }, 0);
  });
  document.addEventListener('shopify:section:load', scheduleEnhance);
  document.addEventListener('wokora:cart-updated', scheduleEnhance);
  document.addEventListener('wokora:cart-drawer-refreshed', scheduleEnhance);
  document.addEventListener('wokora:content-updated', scheduleEnhance);
  window.addEventListener('pageshow', scheduleEnhance);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); }, { once: true });
  else enhance(document);
})();
